import type { FC } from 'react';
import { Suspense, useCallback, useMemo } from 'react';
import { Box } from '@mui/material';
import CheckboxAutocomplete from 'components/common/CheckboxAutocomplete';
import type { OptionValue } from 'components/common/CheckboxAutocomplete';
import { useRedditKeywords } from '../api';

interface TrendsKeywordsFilterProps {
  keywordIds: number[];
  onChange: (value: number[]) => void;
}

const TrendsKeywordsFilterContent: FC<TrendsKeywordsFilterProps> = ({ keywordIds, onChange }) => {
  const { data: keywords } = useRedditKeywords();

  const options = useMemo(
    () => keywords.map((keyword) => ({ value: keyword.id, label: keyword.phrase })),
    [keywords]
  );

  const handleChange = useCallback(
    (value: OptionValue[]) => {
      onChange(value.filter((item): item is number => typeof item === 'number'));
    },
    [onChange]
  );

  return (
    <Box sx={{ flex: 2, minWidth: 200 }}>
      <CheckboxAutocomplete
        id="trends-keyword-autocomplete"
        options={options}
        size="small"
        value={keywordIds}
        InputProps={{ label: 'Keyword' }}
        onChange={handleChange}
      />
    </Box>
  );
};

const TrendsKeywordsFilterFallback: FC = () => (
  <Box sx={{ flex: 2, minWidth: 200 }}>
    <CheckboxAutocomplete
      id="trends-keyword-autocomplete-loading"
      options={[]}
      size="small"
      value={[]}
      isLoading
      InputProps={{ label: 'Keyword' }}
      onChange={() => undefined}
    />
  </Box>
);

const TrendsKeywordsFilter: FC<TrendsKeywordsFilterProps> = (props) => (
  <Suspense fallback={<TrendsKeywordsFilterFallback />}>
    <TrendsKeywordsFilterContent {...props} />
  </Suspense>
);

export default TrendsKeywordsFilter;
